import { DocumentLibDto, LinkedAttachmentDto } from "@app/api";
import { CerFormContext } from "@cer/cer-form/cer-form-context";
import { CerFormView } from "@cer/cer-form/cer-form-view";
import { documentTypeByExtension } from "@cer/cer-form/cer-form-view-type/cer-form-view-type-document/cer-form-view-document-type";
import { CerLink } from "@cer/cer-markdown/cer-link";
import { uiCmdComponentMaximize, uiCmdDocumentDownload, uiCmdDocumentDownloadOriginal, uiCmdDocumentOpenLink } from "@cer/cer-ui/cer-ui-commands";
import { UiCommandEvent } from "@cer/cer-ui/cer-ui-types";
import { CerAppDocumentationLinkHelper } from "src/cer-app/cer-app-documentation/cer-app-documentation-link-helper";

export class DocumentLibAttachmentView extends CerFormView {

  constructor(private docLib: DocumentLibDto, private context: CerFormContext) {
    super({
      title: 'Dokument',
      titleHeaderVisible: true,
      viewType: 'document',
      viewMetadata: {
        text: 'Dokument', textSingular: 'Dokument',
        primaryKey: 'id', titleFields: ['name'], baseFields: ['id', 'name', 'history']
      },
      toolbarCommands: [uiCmdDocumentDownloadOriginal, uiCmdDocumentDownload, uiCmdDocumentOpenLink, uiCmdComponentMaximize],
      onCommandEvent: (e) => { this.onCommand(e) }
    });
  }

  protected attachment: LinkedAttachmentDto;
  public select(attachment: LinkedAttachmentDto, urlUpdate: string) {
    if (attachment?.url == this.documentUrl && attachment == this.attachment) {
      return;
    }
    this.dataFromParent = [attachment];
    this.attachment = attachment;
    const fileName = attachment?.fileName?.length > 0 ? attachment?.fileName + (attachment?.fileExtension ?? "") : null;
    const originalfileName = attachment?.originalFileName?.length > 0 ? attachment?.originalFileName + (attachment?.originalFileExtension ?? "") : null;
    const originalActive = originalfileName?.length > 0 && originalfileName != fileName;
    this.documentType = documentTypeByExtension(attachment?.fileExtension);
    this.documentUrl = attachment?.url;
    this.documentUrlUpdate = urlUpdate;
    this.documentFileName = fileName;
    this.documentOriginalFileName = originalActive ? originalfileName : null;
    this.documentOriginalUrl = originalActive ? attachment?.originalUrl : null;
    this.commandUpdateTitle(this.documentOriginalFileName ?? this.documentFileName);
    this.commandParentData(attachment); // Send to content view, where logic is defined
  }

  private onCommand(e: UiCommandEvent) {
    if (e.actionType == 'linkClicked') {
      this.openLink(e.args as CerLink);
    }
  }

  private openLink(link: CerLink) {
    if (link) {
      new CerAppDocumentationLinkHelper(this.context, this.docLib, this, this.paneTarget).redirectLink(link);
    }
  }
}

